import { createSelector } from 'reselect';
import { RootState } from '../../store';

export const selectAllTargetValue = createSelector(
    (state: RootState) => state.productTargetValue,
    allTargetValue => allTargetValue && allTargetValue.allTargetValue,
);
